import { jwtDecode } from "jwt-decode";
import axios from "../axios";

let accessToken = null;

class AuthServices {

  static Instance() {
    return new AuthServices();
  }

  setAccessToken = (token) => (accessToken = token);

  getAccessToken = () => accessToken;

  clearAccessToken = () => (accessToken = null);

  decodeJwt() {
    if (!accessToken) return null;
    return jwtDecode(accessToken);
  }

  isTokenExpired() {
    const token = this.decodeJwt();
    if (!token || !token.exp) return true;
    return Date.now() >= token.exp * 1000;
  }

  async login(request) {
    try {
      return await axios.post("/api/auth/login", request, { withCredentials: true });
    } catch (error) {
      return error.response || { status: 500, message: "Login Failed" };
    }
  }

  async getUserDetails() {
    try {
      return await axios.get("/api/user/getUserDetails", { withCredentials: true });
    } catch (error) {
      return error.response ?? { status: 500, message: "Failed to get user details" };
    }
  }

  async logout() {
    try {
      await axios.post("/api/auth/logout", {}, { withCredentials: true });
    } finally {
      this.clearAccessToken();
    }
  };

  async registerUser(request) {
    try {
      return await axios.post("/api/auth/register", request);
    } catch (error) {
      return error.response || { status: 500, message: "Registration Failed" };
    }
  }

  generateOtp(request) {
    return axios.post("/api/auth/generate-otp", request);
  }

  forgotPassword(request) {
    return axios.post("/api/auth/forgot-password", request);
  }

  verifyOTP(email, otp) {
    // URL encode the email to preserve special characters like '+'
    const encodedEmail = encodeURIComponent(email);
    return axios.get(`api/auth/verify?email=${encodedEmail}&otp=${otp}`);
  }

  resetPassword(request) {
    return axios.post("/api/auth/reset-password", request)
  }

}

export default AuthServices.Instance();